import React, { Fragment } from 'react'
import { Redirect } from 'react-router'

import RoutesHelper from 'helpers/RoutesHelper'
import { NotePanelLoading } from 'components/Layout/AppLoading'
import { Text } from 'components/base'

import ConfettisImg from './assets/confettis.svg'
import ArrowImg from './assets/arrow.svg'

import './OwnerOnboarding.css'

const OwnerOnboarding = ({
  isOwnerOnboardingActive,
  isOnboardingOnInviteStep,
}) => {
  if (!isOwnerOnboardingActive) {
    return <Redirect replace to={RoutesHelper.app()} />
  }

  return (
    <div className="l-main-body width-full">
      {isOnboardingOnInviteStep ? (
        <NotePanelLoading />
      ) : (
        <Fragment>
          <div className="position-absolute bounce" style={{ top: 270 }}>
            <img src={ArrowImg} alt="create-channel-button" />
          </div>
          <div className="height-full-page width-full flexbox flexbox-column flexbox-align-center">
            <img
              src={ConfettisImg}
              alt="welcome-to-your-team"
              className="margin-vertical-huge"
            />
            <div className="flexbox flexbox-column flexbox-align-center flexbox-justify-start">
              <div className="flexbox flexbox-column flexbox-centered">
                <Text.Title className="margin-bottom-normal center-text">
                  Welcome to your team
                </Text.Title>
                <span
                  style={{ fontSize: 17, lineHeight: '29px' }}
                  className="font-weight-medium center-text"
                >
                  Channels are how you easily organize your team’s information.
                </span>
                <span
                  style={{ fontSize: 17, lineHeight: '29px' }}
                  className="font-weight-medium center-text"
                >
                  Let’s start by creating your first one.
                </span>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  )
}

export default OwnerOnboarding
